export default "__VITE_ASSET__DUFcQY0S__"